var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cr-radio-button"},[_c('el-radio-button',{attrs:{"value":_vm.value,"label":_vm.label},on:{"input":function (label) { return this$1.$emit("input", label); }}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }